import React, { useState } from 'react';
import { useTranslation } from 'react-i18next'
import { createForm } from 'rc-form'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const UpdateInvoiceDialog = props => {
    const { form, open, onClose, sourceData } = props
    const { getFieldProps, getFieldError } = form
    const { t } = useTranslation();
    const [errMsg, setErrMsg] = useState(null)
    const [receiptType, setReceiptType] = useState(sourceData.receiptType || '2')
    const receiptTitleErr = getFieldError('receiptTitle')
    const receiptTaxIdErr = getFieldError('receiptTaxId')

    const handleOnSubmit = () => {
        setErrMsg(null)
        props.form.validateFields((error, value) => {
            if (!error) {
                props.onSubmit({
                    ...value,
                    receiptType: parseInt(receiptType, 10)
                })
            } else {
                setErrMsg('*發票資料不完整或有誤')
            }
        })
    }

    const handleReceiptType = (event) => {
        setReceiptType(event.target.value);
    }

    return (
        <Dialog open={open} onClose={onClose} fullWidth className="update-invoice">
            <DialogTitle style={{ paddingLeft: '32px', borderBottom: '1px solid rgba(74, 79, 85, 0.1)' }}>
                <Grid container justify="space-between" alignItems="center">
                    <Typography variant="h2">
                        {t('udpate_invoice_info')}
                    </Typography>
                    <CloseIcon onClick={onClose} className="pointer" />
                </Grid>
            </DialogTitle>
            <DialogContent style={{ padding: '32px' }}>
                <Grid container>
                    <RadioGroup
                        name="receiptType"
                        value={receiptType}
                        onChange={handleReceiptType}
                        className="receipt-type"
                    >
                        <FormControlLabel value={'2'} label={t('two_line_receipt')}
                            control={<Radio color="primary" />}
                        />
                        <FormControlLabel value={'3'} label={t('three_line_receipt')}
                            control={<Radio color="primary" />}
                        />
                    </RadioGroup>
                </Grid>
                {receiptType === '3' &&
                    <Grid container alignItems="center" style={{ marginBottom: '24px' }}>
                        <Grid item md={2}>
                            <Typography className="text-grey">{t('receipt_title')}</Typography>
                        </Grid>
                        <Grid item md={10}>
                            <TextField
                                margin="dense"
                                name="receiptTitle"
                                id="receiptTitle"
                                variant="outlined"
                                style={{ margin: 0 }}
                                inputProps={{
                                    ...getFieldProps('receiptTitle', {
                                        initialValue: sourceData.receiptTitle,
                                        rules: [{
                                            required: true,
                                            type: 'string',
                                        }]
                                    })
                                }}
                                error={receiptTitleErr && receiptTitleErr !== null}
                            />
                        </Grid>
                    </Grid>
                }
                {receiptType === '3' &&
                    <Grid container alignItems="center">
                        <Grid item md={2}>
                            <Typography className="text-grey">{t('tax_id')}</Typography>
                        </Grid>
                        <Grid container item md={10} alignItems="center">
                            <TextField
                                margin="dense"
                                name="receiptTaxId"
                                id="receiptTaxId"
                                variant="outlined"
                                style={{ margin: 0 }}
                                inputProps={{
                                    maxLength: 8,
                                    ...getFieldProps('receiptTaxId', {
                                        initialValue: sourceData.receiptTaxId,
                                        rules: [{
                                            required: true,
                                            type: 'string',
                                            pattern: /^\d{8}$/,
                                        }]
                                    })
                                }}
                                error={receiptTaxIdErr && receiptTaxIdErr !== null}
                            />
                            <Typography color="error" variant="body2" style={{marginLeft: '20px'}}>{errMsg}</Typography>
                        </Grid>
                    </Grid>
                }
            </DialogContent>
            <DialogActions style={{ padding: '16px 32px', borderTop: '2px solid rgba(74, 79, 85, 0.1)' }}>
                <Button color="primary" variant="contained" onClick={handleOnSubmit}>{t('new')}</Button>
            </DialogActions>
        </Dialog>
    )
}

UpdateInvoiceDialog.defaultProps = {
    sourceData: {},
};

export default createForm()(UpdateInvoiceDialog)